var CookieBanner;

CookieBanner = (function() {
  function CookieBanner(el) {
    this.el = el;
    this.$el = $(this.el);
    this.$body = $('#ls-body');
    this.initialize();
  }

  CookieBanner.prototype.initialize = function() {
    this.delay = 300;
    if (!Cookie.get('acknowledge_cookies')) {
      this.$body.addClass('ls-visible-cookieBanner');
      this.$el.fadeIn(this.delay);
      return this.attachHideListener();
    }
  };

  CookieBanner.prototype.attachHideListener = function() {
    var acknowledgeLink;
    acknowledgeLink = this.$el.find('#ls-accept-cookies');
    return acknowledgeLink.one('click.cookie-banner-action', (function(_this) {
      return function(e) {
        e.preventDefault();
        Groupon.Utils.setSiteCookies({
          acknowledge_cookies: true
        });
        _this.$el.fadeOut(_this.delay).remove();
        return _this.$body.removeClass('ls-visible-cookieBanner');
      };
    })(this));
  };

  return CookieBanner;

})();

window.CookieBanner = CookieBanner;

//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiL1VzZXJzL2FyaWNodGVyL3JlcG9zaXRvcmllcy9zbHMvbW9kdWxlcy9naWdfYm9keS9jb21wb25lbnRzL2Nvb2tpZV9iYW5uZXIvZnJvbnRlbmQvbWFpbi5jb2ZmZWUiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIvVXNlcnMvYXJpY2h0ZXIvcmVwb3NpdG9yaWVzL3Nscy9tb2R1bGVzL2dpZ19ib2R5L2NvbXBvbmVudHMvY29va2llX2Jhbm5lci9mcm9udGVuZC9tYWluLmNvZmZlZSJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQSxJQUFBOztBQUFNO0VBQ1Msc0JBQUMsRUFBRDtJQUFDLElBQUMsQ0FBQSxLQUFEO0lBQ1osSUFBQyxDQUFBLEdBQUQsR0FBTyxDQUFBLENBQUUsSUFBQyxDQUFBLEVBQUg7SUFDUCxJQUFDLENBQUEsS0FBRCxHQUFTLENBQUEsQ0FBRSxVQUFGO0lBQ1QsSUFBQyxDQUFBLFVBQUQsQ0FBQTtFQUhXOzt5QkFLYixVQUFBLEdBQVksU0FBQTtJQUNWLElBQUMsQ0FBQSxLQUFELEdBQVM7SUFDVCxJQUFBLENBQU8sTUFBTSxDQUFDLEdBQVAsQ0FBVyxxQkFBWCxDQUFQO01BQ0UsSUFBQyxDQUFBLEtBQUssQ0FBQyxRQUFQLENBQWdCLHlCQUFoQjtNQUNBLElBQUMsQ0FBQSxHQUFHLENBQUMsTUFBTCxDQUFZLElBQUMsQ0FBQSxLQUFiO2FBQ0EsSUFBQyxDQUFBLGtCQUFELENBQUEsRUFIRjs7RUFGVTs7eUJBT1osa0JBQUEsR0FBb0IsU0FBQTtBQUNsQixRQUFBO0lBQUEsZUFBQSxHQUFrQixJQUFDLENBQUEsR0FBRyxDQUFDLElBQUwsQ0FBVSxvQkFBVjtXQUNsQixlQUFlLENBQUMsR0FBaEIsQ0FBb0IsNEJBQXBCLEVBQWtELENBQUEsU0FBQSxLQUFBO2FBQUEsU0FBQyxDQUFEO1FBQ2hELENBQUMsQ0FBQyxjQUFGLENBQUE7UUFDQSxPQUFPLENBQUMsS0FBSyxDQUFDLGNBQWQsQ0FBNkI7VUFBQSxtQkFBQSxFQUFxQixJQUFyQjtTQUE3QjtRQUNBLEtBQUMsQ0FBQSxHQUFHLENBQUMsT0FBTCxDQUFhLEtBQUMsQ0FBQSxLQUFkLENBQW9CLENBQUMsTUFBckIsQ0FBQTtlQUNBLEtBQUMsQ0FBQSxLQUFLLENBQUMsV0FBUCxDQUFtQix5QkFBbkI7TUFKZ0Q7SUFBQSxDQUFBLENBQUEsQ0FBQSxJQUFBLENBQWxEO0VBRmtCOzs7Ozs7QUFRdEIsTUFBTSxDQUFDLFlBQVAsR0FBc0IifQ==
